// https://app.growthbook.io/features/pen-5824_v1
export const MEMBER_WINS_IN_FOOTER_FLAG_NAME = 'pen-5824_v1'
